{
    "Accessibility menu": "قائمة إمكانية الوصول",
    "Reset settings": "إعادة تعيين الإعدادات",
    "Close": "إغلاق",
    "Content adjustments": "تعديلات المحتوى",
    "Navigation adjustments": "تعديلات التنقل",
    "Align Left": "محاذاة لليسار",
    "Adjust Font Size": "ضبط حجم الخط",
    "Highlight Title": "تمييز العنوان",
    "Highlight Links": "تمييز الروابط",
    "Readable Font": "خط مقروء",
    "Colour adjustments": "تعديلات الألوان",
    "Dark Contrast": "تباين داكن",
    "Light Contrast": "تباين فاتح",
    "High Contrast": "تباين عالي",
    "High Saturation": "تشبع عالي",
    "Low Saturation": "تشبع منخفض",
    "Monochrome": "أحادي اللون",
    "Tools": "الأدوات",
    "Reading Guide": "دليل القراءة",
    "Stop Animations": "إيقاف الرسوم المتحركة",
    "Big Cursor": "مؤشر كبير",
    "Increase Font Size": "زيادة حجم الخط",
    "Decrease Font Size": "تقليل حجم الخط",
    "Letter Spacing": "المسافة بين الحروف",
    "Line Height": "ارتفاع السطر",
    "Font Weight": "سمك الخط",
    "Dyslexia Font": "خط عسر القراءة",
    "Language": "اللغة",
    "Accessibility widget": "فتح قائمة إمكانية الوصول",
    "Accessibility Profiles": "ملفات إمكانية الوصول",
    "Cognitive Disability": "الإعاقة المعرفية",
    "Seizure Safe": "آمن من النوبات",
    "Accessibility statement": "بيان إمكانية الوصول"
}
